import { Draft, produce } from 'immer';

import * as TYPES from '@app/store/actionTypes';
import {
  scheduledDocumentPreviewDataFetched,
  setupTemplateByDraft,
  TemplateAction,
} from '@app/store/template/actions';

type TemplateFieldIdsState = string[];

const initialState: TemplateFieldIdsState = [];

const reducer = produce((draft: Draft<TemplateFieldIdsState>, action: TemplateAction) => {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
      return initialState;
    case scheduledDocumentPreviewDataFetched.type:
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { fields } = participant;
        const { checkboxGroups, signatureFields, textFields } = fields;

        checkboxGroups.forEach((checkboxGroup) => {
          draft.push(checkboxGroup.id);
          checkboxGroup.children.forEach((checkboxField) => {
            draft.push(checkboxField.id);
          });
        });

        signatureFields.forEach((signatureField) => {
          draft.push(signatureField.id);
        });
        textFields.forEach((textField) => {
          draft.push(textField.id);
        });
      });
      return draft;
    }
    case setupTemplateByDraft.type: {
      action.payload.participants.forEach((participant) => {
        participant.fields.forEach((field) => {
          draft.push(field.id);
        });
      });
      return draft;
    }
    case TYPES.TEMPLATE_FIELD_CREATE: {
      const { id } = action.payload.meta;
      draft.push(id);
      return draft;
    }
    case TYPES.TEMPLATE_FIELD_DELETE: {
      const { id } = action.payload;
      draft.splice(
        draft.findIndex((v) => v === id),
        1
      );
      return draft;
    }
    case TYPES.TEMPLATE__FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE:
    case TYPES.TEMPLATE_PARTICIPANT_DELETE: {
      const { fieldIds } = action.payload;
      return draft.filter((v) => !fieldIds.includes(v));
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
